export const utils = {
    isNumeric,
    splitNc,
    isNullString
};
function isLetter(c) {
    return c.toLowerCase() != c.toUpperCase();
}
function splitNc(string) {
    if (string == null) {
        return null;
    }
    let numString = '';
    let subString = '';
    let fineNumeric = false;
    for (let index = 0; index < string.length; index++) {
        const s = string.charAt(index);
        if (fineNumeric) {
            if (isNumeric(s) || isLetter(s)) {
                subString = subString + s;
            }

        } else {
           if  (isNumeric(s)){
            numString=numString+s;

           }else{
               fineNumeric=true;
            if (isNumeric(s) || isLetter(s)) {
                subString = subString + s;
            }  
           }
        }

    }
    if (numString==''){
        numString='0'
    }
    const nc = Number(numString);
    const sub = subString;
    return { nc, sub };
}
function isNullString(s){
    if (s==null || s==''){
        return true;
    }
    return false;
}
function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}